<template>
  <div>
    <naj-box :title="local.caseRelatedRequest.cassationRequest.title">
      <v-row>
        <v-col cols="6">
          <naj-input
            :type-id="formFieldType.selectbox"
            :value.sync="formModel.judgementCode"
            :label="local.caseRelatedRequest.cassationRequest.judgementCode"
            :items="judgments"
            item-value="judgementCode"
            item-text="judgementCode"
            validates="required"
            :disabled="isViewMode || isEditMode"
            @change="setSelectedJudgment"
          >
          </naj-input>
        </v-col>
      </v-row>
    </naj-box>

    <naj-box :title="local.caseRelatedRequest.cassationRequest.reasons">
      <template v-for="(reason,index) in formModel.cassationReasons">
        <v-row :key="index">
          <v-col cols="12">
            <naj-input
              :type-id="formFieldType.checkbox"
              :value.sync="reason.checked"
              :label="reason.label"
              :disabled="isViewMode"
              @change="reasonCheckChanged(index)"
            ></naj-input>
          </v-col>
          <v-col
            v-if="reason.checked"
            cols="6"
            lg="6"
          >
            <naj-input
              :type-id="formFieldType.textarea"
              :value.sync="reason.description"
              label=""
              :disabled="isViewMode"
              validates="required|max:2000|allowed_special_character"
              rows="4"
            ></naj-input>
          </v-col>
        </v-row>
      </template>
    </naj-box>

    <naj-box :title="local.caseRelatedRequest.cassationRequest.cassationRequestAttachment">
        <v-row>
            <naj-alert type="warning">
                <template slot="content">
                    {{ local.caseRelatedRequest.cassationRequest.attachmentAlert }}
                </template>
            </naj-alert>
        </v-row>
        <v-row>
            <v-col v-if="formModel.CassationFile"
                   cols="3">
                <p class="objection-judgment-confirm-text">
                    {{ local.caseRelatedRequest.cassationRequest.cassationRequestAttachment }}
                </p>
                <attachment-card :file="{ ...uploadedFile }"
                                 :show-delete-button="!isViewMode"
                                 @deleteAttachment="showDeleteObjectionNoteModal"
                                 @viewAttachment="viewAttachment"></attachment-card>
            </v-col>
            <v-col v-else
                   class="objection-note-attachment"
                   cols="12">
                <p class="objection-judgment-confirm-text blackColor">
                    {{ local.caseRelatedRequest.cassationRequest.addCassationRequestAttachment }}
                </p>
                <load-local-attachment :max-file-size="5"
                                       :upload-disabled="isViewMode"
                                       @fileSelected="fileSelected">
                </load-local-attachment>
            </v-col>
        </v-row>
    </naj-box>

    <case-judgement-modal
      :selected-judgement="selectedJudgment"
      :modal-visibility="showCaseJudgementModal"
      @modalClose="closeCaseJudgementModal"
    ></case-judgement-modal>

    <render-attachment-modal
      :attachment-file="uploadedFile"
      :modal-visibility="showViewAttachmentModal"
      @modalClose="hideViewAttachmentModal"
    >
    </render-attachment-modal>

    <naj-confirmation
      :show-modal="showDeleteObjectionNoteAttachment"
      color="error"
      :title="local.common.removeConfirmation"
      :message="local.caseRelatedRequest.VerdictObjectionRequest.removeObjectionNoteAttachmentMessage"
      :ok-btn-label="local.common.remove"
      @ok="confirmDeleteObjectionNote"
      @cancel="cancelDeleteObjectionNote"
    ></naj-confirmation>
    <naj-alert-modal
      :show-modal="showAlertModalForCriminalCases"
      type="information"
      :title="local.common.criminalAttachmentTitle"
      :message="local.common.criminalAttachment"
      @onCancelModal="showAlertModalForCriminalCases=false"
    >
    </naj-alert-modal>
  </div>
</template>

<script>
import { mode, socialIdentityTypeEnum, countriesEnum } from '@/helpers/enum';
import { createNamespacedHelpers } from 'vuex';
const { mapState: mapLUTState } = createNamespacedHelpers('LookupsModule');
const { mapState: mapGlobalState } = createNamespacedHelpers('GlobalModule');
const { mapActions } = createNamespacedHelpers('CasesModule');
import CaseJudgementModal from '../../../../cases/case-judgement-modal';
import LoadLocalAttachment from '../../../../../components/shared/attachment-modal/load-local-attachment';
import AttachmentCard from '@/components/shared/attachment-modal/attachment-card';
import RenderAttachmentModal from '@/components/shared/attachment-modal/render-attachment-modal';

export default {
  name: 'CassationRequest',
  inject: ['$validator'],
  components: {
    CaseJudgementModal,
    LoadLocalAttachment,
    AttachmentCard,
    RenderAttachmentModal,
  },
  props: {
    formModel: {
      type: Object,
      default: () => ({}),
    },
    requiredData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      judgments: [],
      reasons: [
        {
          reasonId: 71,
          checked: false,
          description: '',
          label: this.local.cassationObjectionReasons.oppositeOfIslamicLaw,
        },
        {
          reasonId: 72,
          checked: false,
          description: '',
          label: this.local.cassationObjectionReasons.badCourtHierarchy,
        },
        {
          reasonId: 73,
          checked: false,
          description: '',
          label: this.local.cassationObjectionReasons.courtOrCircleUnspecialized,
        },
        {
          reasonId: 74,
          checked: false,
          description: '',
          label: this.local.cassationObjectionReasons.notAccurateDescription,
        },
      ],

      showCaseJudgementModal: false,
      showDeleteObjectionNoteAttachment: false,
      showViewAttachmentModal: false,
      showAlertModalForCriminalCases: false,
      selectedJudgment: {},
    };
  },
  computed: {
    ...mapLUTState(['cassationObjectionReasons']),
    ...mapGlobalState(['userInfo']),
    isViewMode() {
      return this.formModel && this.formModel.mode === mode.view;
    },
    isEditMode() {
      return this.formModel && this.formModel.mode === mode.update;
    },
    isNewMode() {
      return this.$route.params.requestObjectKey === 'new';
    },
    uploadedFile() {
      if (this.formModel.CassationFile && this.formModel.CassationFile.fileData) {
        const fileData = this.formModel.CassationFile.fileData;
        return {
          name: fileData.fileName,
          attachmentKey: fileData.attachmentKey,
          sharePointId: fileData.attachement,
          isImage: fileData.fileType.startsWith('image'),
          fileType: fileData.fileType,
        };
      }
      return {};
    },
    routeRequestObjectKey() {
      return this.$route.query.requestObjectKey;
    },
  },
  watch: {},
  mounted() {
    if (this.formModel) {

      if ((this.formModel.cassationReasons || []).length > 0) {
        this.formModel.cassationReasons.forEach((element) => {
          let item = this.reasons.find(a => a.reasonId == element.reasonId);
          if (item) {
            item.checked = true;
            item.description = element.description;
          }
        });
      }

      this.$set(this.formModel, 'cassationReasons', this.reasons);

      if (this.formModel.judgementCode) {
        this.setSelectedJudgment();
      }
      this.readCurrentUserInfo();
    }

    this.loading = true;
    const params = {
      isPega: this.formModel.isPega,
      objectKey: this.formModel.case.objectKey,
    };

    if (this.routeRequestObjectKey || this.requiredData?.isFromNonCaseParty) {
      this.getJudgementsByRequestObjectKey(this.routeRequestObjectKey ? this.routeRequestObjectKey : this.requiredData?.parentRequestObjectKey)
        .then((res) => {
          this.judgments = res.data;
          this.setSelectedJudgment();
        })
        .finally(() => (this.loading = false));
    }
    else {
      this.getCaseJudgments(params)
        .then((res) => {
          this.judgments = res.data;
          this.setSelectedJudgment();
        })
        .finally(() => (this.loading = false));
    }

  },
  methods: {
    ...mapActions([
      'getCaseJudgments',
      'uploadAttachment',
      'isValidApplicantForCommercialJudgement',
      'getJudgementsByRequestObjectKey',
    ]),
    reasonCheckChanged(index) {
      const selectedReason = this.formModel.cassationReasons[index];
      if (!selectedReason.checked) {
        this.formModel.cassationReasons[index].description = '';
      }
    },
    setSelectedJudgment() {
      this.formModel.judgementCode && this.$set(this, 'selectedJudgment', (this.judgments || []).find(a => a.judgementCode == this.formModel.judgementCode) || {});


      if (this.formModel.judgementCode !== undefined) {
        this.loading = true;
        this.isValidApplicantForCommercialJudgement(this.formModel.judgementCode)
          .then(() => {
            this.$set(this.formModel, 'isApplicantEligibleToApply', true);
          })
          .catch(() => {
            this.$set(this.formModel, 'isApplicantEligibleToApply', false);
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.$set(this.formModel, 'isApplicantEligibleToApply', undefined);
      }
    },
    getJudgementDeed() {
      this.showCaseJudgementModal = true;
    },
    closeCaseJudgementModal() {
      this.showCaseJudgementModal = false;
    },
    fileSelected({ selectedAttachment: attachment, selectedAttachmentKey }) {
      this.loading = true;
      const reader = new FileReader();
      reader.onloadend = () => {
        var b64 = reader.result.replace(/^data:.+;base64,/, '');

        this.uploadAttachment({
          classification: 0,
          documentMetadata: {
            caseId: 0,
            caseCode: 0,
            requestId: 0,
            category: attachment.category,
            fileCategory: attachment.category,
          },
          fileCategory: attachment.category,
          extension: attachment.extension,
          base64FileContent: b64,
        })
          .then(({ data }) => {
            this.$set(this.formModel, 'CassationFile',
              {
                fileData: {
                  attachement: data,
                  fileName: attachment.name,
                  fileType: attachment.fileObject.type,
                  sharePointId: data,
                  extension: attachment.extension,
                  fileCategory: attachment.category,
                  attachmentKey: selectedAttachmentKey,
                },
              }
            );
          })
          .catch(err => this.toaster.error(err.message))
          .finally(() => (this.loading = false));
      };
      reader.readAsDataURL(attachment.fileObject);
    },
    showDeleteObjectionNoteModal() {
      this.showDeleteObjectionNoteAttachment = true;
    },
    confirmDeleteObjectionNote() {
      this.$set(this.formModel, 'CassationFile', null);
      this.cancelDeleteObjectionNote();
    },
    cancelDeleteObjectionNote() {
      this.showDeleteObjectionNoteAttachment = false;
    },
    viewAttachment() {
      if (this.formModel.CassationFile.fileData.hide == true)
        this.showAlertModalForCriminalCases = true;
      else
        this.showViewAttachmentModal = true;
    },
    hideViewAttachmentModal() {
      this.showViewAttachmentModal = false;
    },

    readCurrentUserInfo() {
      if (this.userInfo) {
        const socialTypeId = this.userInfo.socialIdType;
        this.$set(this.formModel, 'socialIdType', socialTypeId);
        this.$set(this.formModel, 'socialId', this.userInfo.socialId);
        this.$set(this.formModel, 'firstName', this.userInfo.firstName);
        this.$set(this.formModel, 'fatherName', this.userInfo.fatherName);
        this.$set(this.formModel, 'grandFatherName', this.userInfo.grandFatherName);
        this.$set(this.formModel, 'familyName', this.userInfo.familyName);
        this.$set(this.formModel, 'dateOfBirth', this.userInfo.dateOfBirth);
        this.$set(this.formModel, 'nationalityCountryId', socialTypeId === socialIdentityTypeEnum.nationalId ? countriesEnum.saudiArabia : this.userInfo.nationalityCountryId);
        this.$set(this.formModel, 'sex', this.userInfo.gender);
        this.$set(this.formModel, 'isRetrievedFromMoi', true);
        this.$set(this.formModel, 'fullName', this.userInfo.fullName);
        this.$set(this.formModel, 'relatedPartyID', this.userInfo.relatedPartyID);
      } else {
        this.$set(this.formModel, 'socialIdType', null);
        this.$set(this.formModel, 'socialId', null);
        this.$set(this.formModel, 'firstName', null);
        this.$set(this.formModel, 'fatherName', null);
        this.$set(this.formModel, 'grandFatherName', null);
        this.$set(this.formModel, 'familyName', null);
        this.$set(this.formModel, 'dateOfBirth', null);
        this.$set(this.formModel, 'nationalityCountryId', null);
        this.$set(this.formModel, 'sex', null);
        this.$set(this.formModel, 'isRetrievedFromMoi', false);
        this.$set(this.formModel, 'fullName', null);
        this.$set(this.formModel, 'relatedPartyID', null);
      }
    },
  },
};

</script>

<style lang="scss" scoped>
.judgement-deed {
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .v-input--radio-group {
  .options-list {
    display: inline-grid !important;
  }
}

::v-deep .attachment-item {
  cursor: pointer;
}

.request-reasons-title {
  font-size: 18px;
}

.memorandum-challenge-alert-container {
  .alert-notification {
    display: block;
    color: #f6c645;
    font-size: 14px;
  }

  .message {
    font-size: 16px;
    color: #faad14;
  }
}

.objection-judgment-confirm-text {
  color: darkred;
  font-size: 1rem;
  margin-bottom: 0;
}

.objection-note-attachment {
  display: flex;

  .objection-judgment-confirm-text {
    margin-left: 10px;
  }

  .uplaod-attachments-button .img-actions {
    width: 100% !important;
  }
}

::v-deep .attachment-item {
  cursor: pointer;
}
.blackColor {
  color: black;
}
</style>